import PropTypes from 'prop-types';
import TreeItem from '../Components/TreeNavigator/TreeItem';

const TreeNavigatorPropTypes = {
  tree: PropTypes.arrayOf(PropTypes.instanceOf(TreeItem)).isRequired,
};

export default TreeNavigatorPropTypes;
